<template>
	<div class="left-banner" id="leftBan">
		<div class="cloud-icon" @click.stop="toMainHomePage()">
			<div class="cloud-icon-position">
				<div class="cloud-image"></div>
				<div class="cloud-description" :style="{ fontSize: this.$i18n.locale != 'english' ? '10Px' : '' }">{{$t('language.leftBanner.logoSlogan')}}</div>
			</div>
		</div>
		<!-- 菜单分类 -->
		<div class="navigation-menu">
			<!-- 功能菜单 -->
			<div class="menu-option-title">
				{{$t('language.leftBanner.commonTools')}}
			</div>
			<div id="functionMenu" class="function-menu menu-options">
				<!-- 菜单 -->
				<div v-show="checkMenuShow(option)" class="menu-option" :class="option.id==menuClickCurrent?'menu-option-select':''" v-for="option in menuOptions" :key="option.id" @click="menuOptionSelect(option.id)" :id="option.id==100?'taskList':null">
					<div class="icon" :class="option.id==menuClickCurrent?option.icon:(option.icon+'-black')"></div>
					<div class="option-name">
						{{$t("language.leftBanner."+option.name)}}
					</div>
					<div class="option-num" v-if="option.hasNewNum&&getMenuOptionNewNum(option.hasNewNum)">{{getMenuOptionNewNum(option.hasNewNum)}}</div>
				</div>
				<!-- 新手引导第一步 -->
				<div class="step-one" v-if="$store.state.beginGuideFlag&&guideStepOne&&!$store.state.isLiteMode">
					<div class="bubble bubble-one-position">
						<div class="bubble-triangle"></div>
						<div class="icon-util bubble-close" style="float:right;" @click="cancelGuide()"></div>
						<div class="bubble-text">{{$t('language.leftBanner.createTaskText')}}</div>
						<button class="bubble-button" @click="nextStepTwo()">{{$t('language.popup.reportPopup.next')}}</button>
					</div>
				</div>
				<!-- 新手引导ins -->
				<div class="step-ins" v-if="$store.state.insGuideFlag&&guideStepIns">
					<div class="bubble bubble-one-position">
						<div class="bubble-triangle"></div>
						<div class="icon-util bubble-close" style="float:right;" @click="closeInsGuide()"></div>
						<div class="bubble-text">{{ $t('language.imageSaver.noviceGuidance') }}</div>
						<button class="bubble-button" @click="closeInsGuide()">{{$t('language.leftBanner.gotIt')}}</button>
					</div>
				</div>
				<!-- 新手引导google_photos_v2_tips_popup -->
				<div class="step-google-photos-v2-tips-box" v-if="$store.state.googleGuideFlag&&guideStepGoogle">
					<div class="step-google-photos-v2-tips" :style="bubbleStyle" :language="this.$i18n.locale">
						<div class="bubble bubble-google-position">
							<div class="bubble-triangle"></div>
							<div class="icon-util bubble-close" style="float:right;" @click="closeGoogleGuide()"></div>
							<div class="bubble-text">{{$t('language.popup.cloudExploerPopup.googlePhotosV2AddMoreTips')}}</div>
							<button class="bubble-button" @click="closeGoogleGuide()">{{$t('language.common.ok')}}</button>
						</div>
					</div>
				</div>
				<!-- 新手引导google_photos_v2传输、同步、备份源 -->
				<div class="step-google-photos-v2-tips-box2" v-if="$store.state.googleGuideFlag2&&guideStepGoogle2">
					<div class="step-google-photos-v2-tips2" :style="bubbleStyle2">
						<div class="add-more-photos-icon"></div>
						<div class="bubble bubble-google-position2">
							<div class="bubble-triangle"></div>
							<div class="icon-util bubble-close" style="float:right;" @click="closeGoogleGuide2()"></div>
							<div class="bubble-text">{{$t('language.popup.cloudExploerPopup.googlePhotosV2AddMoreTips')}}</div>
							<button class="bubble-button" @click="closeGoogleGuide2()">{{$t('language.common.ok')}}</button>
						</div>
					</div>
				</div>
			</div>
			<div class="menu-option-title">
				{{$t('language.leftBanner.onlineServices')}}
			</div>
			<!-- 添加云盘或邮件菜单 -->
			<div id="addMenu" class="add-menu menu-options">
				<!-- 添加云盘 -->
				<div class="menu-option" @click="menuOptionSelect(901)" :class="901==menuClickCurrent?'menu-option-select':''">
					<div class="icon" :class="901==menuClickCurrent?'addCloudIcon':'addCloudIcon-black'"></div>
					<div class="option-name">
						{{$t('language.common.addCloud')}}
					</div>
				</div>
				<!-- 添加邮件 -->
				<div v-show="!$store.state.isLiteMode" class="menu-option" @click="menuOptionSelect(902)" v-if="tabCategories==1" :class="902==menuClickCurrent?'menu-option-select':''">
					<div class="icon" :class="902==menuClickCurrent?'addEmailIcon':'addEmailIcon-black'"></div>
					<div class="option-name">
						{{$t('language.common.addEmail')}}
					</div>
				</div>
				<!-- 子账号团队分享 -->
				<div v-show="!$store.state.isLiteMode" class="menu-option" @click="menuOptionSelect(903)" v-if="hasTeam&&hasTeam.id" :class="(903==menuClickCurrent||8==menuClickCurrent)?'menu-option-select':''">
					<div class="icon" :class="(903==menuClickCurrent||8==menuClickCurrent)?'team-white-small':'team-white-small-black'"></div>
					<div class="option-name">
						{{$t('language.common.team')}}
					</div>
				</div>
				<div class="step-two" v-if="$store.state.beginGuideFlag&&guideStepTwo&&!$store.state.isLiteMode">
					<div class="bubble bubble-one-position">
						<div class="bubble-triangle"></div>
						<div class="icon-util bubble-close" style="float:right;" @click="cancelGuide()"></div>
						<div class="bubble-text">{{$t('language.leftBanner.addCloudText')}}</div>
						<button class="bubble-button" @click="cancelGuide()">{{$t('language.common.done')}}</button>
					</div>
				</div>
			</div>
			<!-- 云盘菜单 -->
			<div id="driveMenu" class="drive-menu" ref="driveMenu">
				<el-scrollbar ref="driveScrollbar" style="position: absolute;width: -webkit-fill-available;height:100%;" :style="driveMenuHeight" :class="(editShow||editNameId)?'not-scroll':''">
					<div class="menu-options" ref="driveMenuOptions">
						<div v-show="$store.state.isLiteMode" @click="menuOptionSelect(108)" style="width:100%;">
							<LiteDrive @noneDrive="noneDrive()" />
						</div>
						<div v-show="!$store.state.isLiteMode" class="menu-option" @mouseenter="handleMouseEnter(cloud)" :data-id="cloud.id" :data-type="cloud.appName" v-for="(cloud,index) in clouds" :key='cloud.id' :ref="`driveMenu-${cloud.id}`" :style="hideEmail(cloud)?'display: none;':''" :class="cloud.id==menuClickCurrent?'menu-option-select':''" @contextmenu.prevent="editDriveMenushow($event,index,cloud)" @click="addDriveSelect(cloud.id,cloud,false)">
							<div class="option-icon">
								<img :src="require('../../assets/images/drive/logo/'+cloud.appName+'.svg')">
								<!-- <div class="icon" :class="cloud.appName!='NAS'?cloud.appName+'-small':cloud.appName+'-white-small'"></div> -->
							</div>
							<div class="option-name" :title="cloud.name" v-if="cloud.id != editNameId">
								<span>{{cloud.name}}</span>
								<div class="option-email-btn" :style="bubbleStyle3">
									<div class="task-icon googlePhotos_big"></div>
									<div class="option-email">
										{{ cloud.driveInfo.authAccountId }}
									</div>
									<div class="option-btn">
										<button @click.stop="handleDisconnect($event,index,cloud)">Disconnect from Google Photos</button>
									</div>
								</div>
							</div>
							<div class="edit-outclass" v-else @click.stop="isflage=true">
								<div class="edit-innerclass">
									<input class="drive-name-edit" :ref="`editInput-${cloud.id}`" v-model="editName" @focus="isflage=true" @blur="submitDriveName(cloud,index)" />
									<span class="drive-input-icon">
										<i class="icon-util name-sure" @click.stop='submitDriveName(cloud,index)'></i>
										<i class="icon-util name-cancel " @mousedown.stop='cancelEditDriveName(cloud,index)'></i>
									</span>
								</div>
							</div>
						</div>
						<div class="edit-drives-menus" v-show="editShow" id="editDrivesMenus" v-clickoutside="editDrivesMenusClose" @mouseout="selectCloud=null">
							<div class="edit-drive-menu" @click.stop="editDriveName()">
								<div class=" rename edit-drive-position new-position"></div>
								<div style="float:left;">{{$t('language.common.rename')}}</div>
							</div>
							<div class="edit-drive-menu" @click.stop="rewriteDrive()">
								<div class="icon-util edit-small edit-drive-position"></div>
								<div style="float:left;">{{$t('language.leftBanner.edit')}}</div>
							</div>
							<div class="edit-drive-menu" @click.stop="removeDialogShow()">
								<div class=" delete edit-drive-position new-position"></div>
								<div style="float:left;">{{ isEditGooglePhotosV2 ? 'Disconnect' : $t('language.leftBanner.remove')}}</div>
							</div>
							<div class="edit-drive-menu" @click.stop="propertiesDialogShow()">
								<div class=" properties edit-drive-position new-position" style="left:1Px;"></div>
								<div style="float:left;">{{$t('language.common.properties')}}</div>
							</div>
						</div>
					</div>
				</el-scrollbar>
			</div>
			<!-- 底部菜单 -->
			<div id="footerMenu" class="footer-menu menu-options">
				<div class="menu-option" @click="menuOptionSelect(9)" :class="9==menuClickCurrent?'menu-option-select':''">
					<div class="icon ap_green_title"></div>
					<div class="option-name">
						{{$t('language.affiliateProgram.leftTitle')}}
					</div>
				</div>
				<div class="menu-option" @click="menuOptionSelect(12)" :class="12==menuClickCurrent?'menu-option-select':''">
					<div class="icon if_Invite_friends"></div>
					<div class="option-name">
						{{$t('language.leftBanner.inviteFriends')}}
					</div>
				</div>
				<div v-if="showLiteSwitch" class="lite_switch_span"></div>
				<div v-if="showLiteSwitch" class="menu-option" @click="liteSwitch()">
					<div class="icon lite_switch"></div>
					<div class="option-name">
						{{ $store.state.isLiteMode ? 'Switch to MultCloud Full' : 'Switch to MultCloud Lite' }}
					</div>
				</div>
			</div>
		</div>
		<!-- <div class="progressive-line"></div> -->
		<propertiesDialog ref="propertiesDialog" :cloudName=cloudName :cloudId=cloudId :cloud=cloud></propertiesDialog>
		<removeDialog ref="removeDialog" :cloudId=cloudId></removeDialog>
		<editCloudDialog ref="editCloudDialog" :cloudType=cloudName :cloudId=cloudId></editCloudDialog>
		<editFtpDialog ref="editFtpDialog"></editFtpDialog>
		<editNasDialog ref="editNasDialog"></editNasDialog>
		<userStarPopup ref="userStarPopup"></userStarPopup>
      	<userStarJumpPopup ref="userStarJumpPopup"></userStarJumpPopup>
      	<userStarFeedbackPopup ref="userStarFeedbackPopup"></userStarFeedbackPopup>
		<!-- <div class="guide-popup" v-if="$store.state.beginGuideFlag"></div> -->
	</div>
</template>

<script>
	import LiteDrive from "@/components/workspace/lite_drive"
	import {
		error
	} from 'util';
	import commonUtils from "@/js/workspace/common_util.js";
	import propertiesDialog from "@/components/popup/add_cloud_popups/properties_popup";
	import removeDialog from "@/components/popup/add_cloud_popups/remove_popup";
	import editCloudDialog from "@/components/popup/add_cloud_popups/edit_cloud_popup";
	import cloudExploerUtils from "@/js/workspace/cloud_exploer_util.js";
	import taskListUtils from "@/js/workspace/task_list_util.js";
	import editFtpDialog from '@/components/popup/add_cloud_popups/edit_ftp_popup';
	import editNasDialog from '@/components/popup/add_cloud_popups/edit_nas_popup';
	import commonstate from '@/js/constant.js';
	import taskOfflineUtils from '@/js/workspace/task_offline_util.js';
	import addCloudUtils from "@/js/workspace/add_cloud_utils.js";
	import userStarPopup from "@/components/popup/task_list_popups/user_star_popup";
	import userStarJumpPopup from "@/components/popup/task_list_popups/user_star_jump_popup";
	import userStarFeedbackPopup from "@/components/popup/task_list_popups/user_star_feedback_popup";
	export default {
		name: 'leftBanner',
		components: {
			LiteDrive,
			propertiesDialog,
			removeDialog,
			editCloudDialog,
			editFtpDialog,
			editNasDialog,
			userStarPopup,
    		userStarJumpPopup,
    		userStarFeedbackPopup,
		},
		computed: {
			addEmailNotNew: {
				get(){
					return commonUtils.getActiveTagByStore("addEmailNotNew");
				},
				set(){}
			},
			bubbleStyle() {
				return {
					left: `${this.$store.state.googleGuideFlagLeft}px`
				}
			},
			bubbleStyle2() {
				return {
					left: `${this.$store.state.googleGuideFlag2X}px`,
					top: `${this.$store.state.googleGuideFlag2Y}px`
				}
			},
			bubbleStyle3() {
				return {
					left: `${this.googlePhotosV2InfoX}px`,
					top: `${this.googlePhotosV2InfoY}px`
				}
			},
		},
		data() {
			return {
				// showLiteSwitch: commonUtils.getUser().username=='test_lite',
				showLiteSwitch: true,
				menuClickCurrent: this.$store.getters.getleftbannerMenuClick,
				cloudIndex: -1,
				cloudName: null,
				cloudId: null,
				cloud: '',
				clouds: [],
				editShow: false,
				isEditGooglePhotosV2: false,
				editName: '',
				editNameId: '',
				isflage: true, //用于控制是否聚焦
				guideStepOne: false,
				guideStepTwo: false,
				guideStepIns: true,
				guideStepGoogle: true,
				guideStepGoogle2: true,
				selectCloud: null,
				selectItem: null,
				editCloud: null,
				hasTeam:null,
                user:commonUtils.getUser(),
				tabCategories: this.$store.getters.getTabCategories,//默认菜单选项类型
				menuOptions: this.$menu.getMenuOptions(1), //左侧菜单栏
				driveMenuHeight: '',
				tabDefaultMenuMap: {},//一级导航默认菜单map
				lastGATime: 0,//最后GA记录的时间，避免重复记录GA，作为判断依据
				googlePhotosV2InfoX: 0,
				googlePhotosV2InfoY: 0,
			}
		},
		inject: ["reload"],
		watch: {
			'$store.getters.getUsersDrives': function(newValue, oldValue) {
				let that = this;
				if (this.$store.getters.getUsersDrives.length) {
                    if(!oldValue.length){
                    this.clouds = Object.assign([], newValue);
                   }else{//如果含有数据，只是更新了数据
                    $.each(this.clouds,function(i,item){
                        $.each(newValue,function(j,jItem){
                            if(item.id==jItem.id){
                                if(item.inputValue){
                                if(item.name!=jItem.name){
                                    jItem.indexCurrent=item.indexCurrent;
                                    jItem.name=item.name;
                                }
                                jItem.inputValue=item.inputValue;
                                }
                            }
                        })
                    });
                   this.clouds= Object.assign([],newValue);
                    }
				}
				// 如果没有云盘有使用Lite版
				// if (!this.clouds.length) {
				// 	this.liteSwitch();
				// }
                //如果没有添加云盘则跳到add_cloud界面,暂时无需此功能
                // if(!this.clouds.length){
                //     this.menuOptionSelect(6);
                // }
			},
			'$store.state.teamCloud':{ //监听的对象
				deep:true, //深度监听设置为 true
				handler:function(newV,oldV){
					this.hasTeam = newV;
				}
			},
			'$store.state.leftbannerMenuClick': {
				handler:function(newV,oldV){
					//触发切换菜单
					this.menuClickCurrent = newV;
					//保存当前一级导航默认跳转页
					this.tabDefaultMenuMap[this.tabCategories] = newV;
					if(newV.length>5) {
						//如果是云盘id的格式
						const cloudIndex = this.clouds.findIndex(item => item.id == newV);
						if(cloudIndex>-1) {
							//如果有该云盘
							const cloud = this.clouds[cloudIndex]
							//如果路由已经在该云盘了，则无需跳转根目录
							if(newV == this.$route.query.tokenId && cloud.driveType == this.$route.query.cloudType) {
								return;
							}else {
								//跳转云盘根目录
								this.addDriveSelect(cloud.id,cloud,false);
							}
						}
					}else {
						this.handleSelect(newV);
					}
				}
			},
			'$store.state.tabCategories': { //监听的对象
				handler:function(newV,oldV){
					//触发切换标签页类型
					this.switchTabCategories(newV);
				}
			},
			clouds(newValue,oldValue) {
				if(newValue) {
					//云盘页面时，初始化左侧栏选中效果
					this.getMenuOption();
				}
        	},
		},
		mounted() {
			let that = this;
			//初始化图片保存任务
			this.loadImageSaverTasks();
			//禁用拖拽功能
			commonUtils.dragDisAble('leftBan', this);
			//浏览器窗口监听
			window.addEventListener('resize', this.driveMenuHeightChange);
			//初始化参数
			let menuClickCurrent = -1;
			let tabCategories = 1;
			if(localStorage.getItem("leftbannerMenuClick"+this.user.id)) {
				menuClickCurrent = Base64.decode(localStorage.getItem("leftbannerMenuClick"+this.user.id));
				if(menuClickCurrent != 903 && this.$route.query.tokenId) {
					//如果不是团队云盘，但是有云盘id
					menuClickCurrent = this.$route.query.tokenId;
				}
			}
			if(localStorage.getItem("tabCategories"+this.user.id)) {
				tabCategories = Base64.decode(localStorage.getItem("tabCategories"+this.user.id));
			}
			if(tabCategories && tabCategories!=-1 && menuClickCurrent) {
				this.tabDefaultMenuMap[tabCategories] = menuClickCurrent;
				this.switchTabCategories(tabCategories);
			}else {
				this.switchTabCategories(1);
			}
			// 云盘授权完成自动进入Lite
			const authResult = this.$cookies.get("authResult");
			if (authResult && !this.$store.state.isLiteMode) {
				this.liteSwitch();
			} else  {
				// 上次是Lite模式
				const uid = commonUtils.getUser().id;
				if (localStorage.getItem('isLiteMode_' + uid) == 'Y') {
					this.liteSwitch();
				}
			}
		},
		beforeDestroy() {
			//移除浏览器窗口监听
			window.removeEventListener('resize', this.driveMenuHeightChange);
		},
		created(){
			//查询是否是子账号
			this.hasPermission();
		},
		methods: {
			checkMenuShow(option) {
				const name = option.name;
				if (this.$store.state.isLiteMode) {
					if (commonUtils.getUser().username=='test_lite') {
						return name=='taskList' || name=='cloudTransfer' || name=='cloudSync' || name=='cloudBackup';
					} else {
						return name=='taskList' || name=='cloudTransfer' || name=='cloudSync';
					}
				} else {
					return name!='liteFile';
				}
			},
			// 鼠标进入左边云盘
			handleMouseEnter(cloud) {
				if (cloud.appName == "googlePhotosV2") {
					const temp = this.$refs.driveMenuOptions
					const el = temp.querySelector(`.menu-option[data-id="${cloud.id}"]`);
					if (el) {
						const rect = el.getBoundingClientRect();
						const x = rect.left + window.scrollX;
						const y = rect.top + window.scrollY;
						this.googlePhotosV2InfoX = x + 200;
						this.googlePhotosV2InfoY = y - 70;
					}
				}
			},
			//自动选中对应菜单
			clickMenuIndex(index) {
				this.menuClickCurrent = index;
				//保存当前一级导航默认跳转页
				this.tabDefaultMenuMap[this.tabCategories] = index;
				if(index&&index.length>5) {
					//如果是云盘id的格式
					const cloudIndex = this.clouds.findIndex(item => item.id == index);
					if(cloudIndex>0) {
						//如果有该云盘
						const cloud = this.clouds[cloudIndex]
						this.addDriveSelect(cloud.id,cloud,false);
					}
				}else {
					this.handleSelect(index);
				}
			},
			//初始化菜单
			initLeftMenu() {
				//初始化菜单
				//获取缓存的参数
				let tabCategories;
				if(localStorage.getItem("tabCategories"+this.user.id)) {
					tabCategories = Base64.decode(localStorage.getItem("tabCategories"+this.user.id));
				}
				if(tabCategories&&tabCategories!=-1) {
					let leftbannerMenuClick = Base64.decode(localStorage.getItem("leftbannerMenuClick"+this.user.id));
					if(leftbannerMenuClick) {
						//初始化记录
						this.tabDefaultMenuMap[tabCategories] = leftbannerMenuClick;
					}
					if(this.tabCategories != tabCategories || this.menuClickCurrent != leftbannerMenuClick) {
						//如果当前页面参数和缓存不同，则初始化
						this.switchTabCategories(tabCategories);
					}
					this.$store.commit("setTabCategories", tabCategories);
				}else {
					this.$store.commit("setTabCategories", 1);
				}
			},
			//自动适配driveMenu的高度
			driveMenuHeightChange() {
				this.$nextTick(() => {
					if(this.$refs.driveMenu&&this.$refs.driveMenu.offsetHeight>0) {
						this.driveMenuHeight = "height:"+this.$refs.driveMenu.offsetHeight+"px;";
					}
					this.$nextTick(() => {
						if (this.$refs.driveScrollbar) {
							this.$refs.driveScrollbar.update();
						}
					});
				});
			},
			// 列出图片保存任务
			loadImageSaverTasks() {
				taskListUtils.imageSaverRequest("/list", {}, res => {
					if (res.code == 200) {
						commonUtils.updateImageSaverTasks(res.data);
					} else if (res.message == 'saltInvalid') {
						commonUtils.logoutAndJumpToSign();
					}
				});
			},
            //判断游客登录新手引导是否显示
            judgeGuideSHow(){
				let user=commonUtils.getUser();
				let newSign = localStorage.getItem("noviceGuide"+user.id);
				//获取当前浏览器类型
				let type = commonUtils.judgeClient();
				if(type == 'Android'||type == 'IOS'){
					//手机端需要在新手指引前打开，暂不开放
					// this.$parent.$refs.rightContBan.appRecommendShow();
				}
				if (!user.loginTime&&!newSign) {
					this.$store.state.beginGuideFlag = true;
					this.guideStepOne = true;
					localStorage.setItem("noviceGuide"+user.id,true);
				}else{
					this.$parent.$refs.rightContBan.appRecommendShow();
				}
            },
			//跳转到主页面
			toMainHomePage() {
                let language = commonUtils.getLocaleToIndex(localStorage.getItem("locale"));
                if(language!='en'){
                 window.open(commonstate.frontEndUrl+'/'+language+ "/");
                }else{
                 window.open(commonstate.frontEndUrl + "/");    
                }
			}, 
			//如果刷新界面后，先判断之前缓存中是否有选中的项
			getMenuOption() {
                let menuclick = this.$store.getters.getleftbannerMenuClick;
				if(!menuclick||menuclick == -1) {
					//没有默认页面时，进入homePage
					// this.$router.push({
					// 	name: 'homePage'
					// });
				}else {
					if(!this.$route.query.tokenId || menuclick==903) {
						//为team时，有tokenId也要选中
						// console.log(this.menuClickCurrent)
						// if(this.menuClickCurrent != menuclick) {
						// 	this.menuClickCurrent = menuclick;
						// 	this.menuOptionSelect(this.menuClickCurrent);
						// }
					}else {
						//携带有tokenId时
						const cloudIndex = this.clouds.findIndex(item => item.id == this.$route.query.tokenId);
						if(cloudIndex>0) {
							//如果有该云盘
							const cloud = this.clouds[cloudIndex]
							this.addDriveSelect(cloud.id,cloud,false);
						}
						// if(this.$refs[`driveMenu-${this.$route.query.tokenId}`]) {
						// 	this.menuClickCurrent = this.$route.query.tokenId;
						// 	if(!this.isOptionVisible(this.$route.query.tokenId)) {
						// 		this.scrollToOption(this.$route.query.tokenId);
						// 	}
						// }
					}
				}
			},
			closeGoogleGuide() { //关闭Google新手引导
				this.guideStepGoogle = false;
				this.$store.state.googleGuideFlag = false;
			},
			closeGoogleGuide2() { //关闭Google新手引导
				this.guideStepGoogle2 = false;
				this.$store.state.googleGuideFlag2 = false;
			},
			closeInsGuide() { //关闭Ins新手引导
				this.guideStepIns = false;
				this.$store.state.insGuideFlag = false;
			},
			cancelGuide() { //取消新手指引
				this.$store.state.beginGuideFlag = false;
				this.guideStepOne = false;
				this.guideStepTwo = false;
                if(this.user.userExpandList && this.user.userExpandList[0].value === 'auth1') {
                    //兑换码活动用户弹出兑换码
                    this.$parent.$refs.rightContBan.openLicenseCodePopup(true);
                }else {
                    this.$parent.$refs.rightContBan.showFunnel();
                }
			},
			nextStepTwo() { //新手指引第二步
				this.guideStepOne = false;
				this.guideStepTwo = true;
			},
			editDriveName() { //编辑云盘名称
				let cloud = this.clouds[this.cloudIndex];
				this.editNameId = cloud.id;
				this.editName = cloud.name;
				this.editShow = false;
				this.$nextTick(() => {
					let inputDom = this.$refs[`editInput-${cloud.id}`];
					if(inputDom) {
						inputDom[0].select();
					}
				});
			}, 
			//取消编辑云盘效果
			cancelEditDriveName(cloud, index) {
				this.isflage = false;
				this.editNameId = "";
			}, //提交云盘名
			submitDriveName(cloud, index) {
				let that = this;
				if (this.isflage) {
					if (this.editName.length > 200) {
						this.$toast({
							text: that.$t('language.home.cloudDiskName'),
							type: 'fail',
							idValue: "leftBan"
						});
						this.cancelEditDriveName(cloud, index);
						return false;
					}
					if (commonstate.patternDriveName.test(this.editName)) {
						that.$toast({
							text: that.$t('language.home.driveNameNotContain'),
							type: 'fail',
							idValue: "leftBan",
						});
						this.cancelEditDriveName(cloud, index);
						return false;
					}
					if (this.editName == cloud.name) {
						this.cancelEditDriveName(cloud, index);
						return false;
					}
					let renameData = new addCloudUtils.renameDrive(commonUtils.getUser().id, cloud.id, this.editName);

                    this.isflage = false;
					this.cancelEditDriveName(cloud, index);
					
					cloud.name = this.editName;

					this.Utils.doDrivesRequest("rename", renameData).then(res => {
						if (res.status == '200') {
							that.isflage = true;
							cloud = res.drive;
							that.$store.commit("setUsersDrives", that.clouds);
							if (that.$parent.$refs.routView.clouds) {
								that.$parent.$refs.routView.clouds = that.clouds;
							}
							if (that.$parent.$refs.routView.pathJson) { //修改用户在当前目录路径
								let pathJson = that.$parent.$refs.routView.pathJson;
								$.each(pathJson, function(i, item) { //修改用户在当前目录路径
									if (item.driveId == cloud.id) {
										item.name = cloud.name;
										that.$store.commit("setPathJson", {
											folderId: pathJson[pathJson.length - 1].id + cloud.id,
											json: pathJson
										});
										that.updateAllPathJson(cloud); //更改该节点的所有目录节点
										return false;
									}
								});
							}
							that.$nextTick(function() {
								if (that.menuClickCurrent == -1) {
									this.$store.commit('setleftbannerMenuClick', cloud.id);
								}
							});
						} else {
							that.$toast({
								text: this.$t('language.exception.' + res.reason),
								type: 'fail',
								idValue: "leftBan"
							});
						}
					});
				}
			}, //修改云盘所有的路径
			updateAllPathJson(cloud) {
				let that = this;
				let allPathJson = this.$store.state.pathJson;
				$.each(allPathJson, function(index, jsonItem) {
					let pathJson = jsonItem.json;
					$.each(pathJson, function(i, item) {
						if (item.driveId == cloud.id) {
							item.name = cloud.name;
							that.$store.commit("setPathJson", {
								folderId: pathJson[pathJson.length - 1].id + cloud.id,
								json: pathJson
							});
							return false;
						}
					});
				});
			}, 
			handleDisconnect(event, index, cloud) {
				this.cloudIndex = index;
				this.removeDialogShow();
			},
            //显示云盘右键菜单
			editDriveMenushow(event, index, cloud) {
				
				this.selectItem = cloud;
				this.selectCloud = cloud;
				cloud.indexCurrent = index;
				this.editCloud = cloud;
				this.cloudIndex = index;
				if (this.$parent.$refs.routView.clouds) {
					this.$parent.$refs.routView.editHomeShow = false;
				}
				let element = event.currentTarget;
                cloud.inputValue = cloud.name;
				cloud.oldDriveName = cloud.name;
				this.$nextTick(function() {
					commonUtils.multipleMenuShow("editDrivesMenus", event);
				});
				this.editShow = true;
				this.isEditGooglePhotosV2 = (cloud.appName== "googlePhotosV2");
			},
			editDrivesMenusClose() {
				this.editShow = false;
			},
			//切换标签页分类，进入标签首页并切换左侧栏标签
			switchTabCategories(type) {
				this.tabCategories = type;
				this.menuOptions = this.$menu.getMenuOptions(this.tabCategories);
				this.driveMenuHeightChange();
				/**
				 * 1：云盘传输功能页
				 * 3：视频下载功能页
				 * 4：云盘列表功能页
				 */

				//初始化选中菜单
				let defaultMenu = this.tabDefaultMenuMap[type];
				if(defaultMenu) {
					this.$store.commit('setleftbannerMenuClick', defaultMenu);
					if(defaultMenu==-1) {
						this.$router.push({
							name: 'homePage'
						});
					}
				}else if(type==1) {
					this.$store.commit('setleftbannerMenuClick', -1);
				}else if(type==2) {
					this.$store.commit('setleftbannerMenuClick', 201);
				}else if(type==3) {
					this.$store.commit('setleftbannerMenuClick', 301);
				}else if(type==4) {
					this.$store.commit('setleftbannerMenuClick', 401);
				}
				this.clickMenuIndex(defaultMenu);
			},
			noneDrive() {
				this.menuOptionSelect(901);
			},
			liteSwitch() {
				this.$store.state.isLiteMode = !this.$store.state.isLiteMode;
				const uid = commonUtils.getUser().id;
				if (this.$store.state.isLiteMode) {
					this.switchTabCategories(1);
					this.menuOptionSelect(100);
					this.$store.state.tabCategories = 1;
					localStorage.setItem('isLiteMode_' + uid, "Y");
				} else {
					this.menuOptionSelect(100);
					localStorage.setItem('isLiteMode_' + uid, "N");
				}
				this.driveMenuHeightChange();
			},
            //选中上面的菜单
			menuOptionSelect(index) {
				this.$store.commit('setleftbannerMenuClick', index);
			}, 
			//选中云盘列表
			driveOptionSelect(index) {
				if(!this.isOptionVisible(index)) {
					this.scrollToOption(index);
				}
				this.$store.commit('setleftbannerMenuClick', index);
			}, 
			//未在视口内则滚动到视口内
			scrollToOption(index) {
				this.$nextTick(() => {
					const element = this.$refs[`driveMenu-${index}`][0];
					if (element) {
						element.scrollIntoView({ behavior: 'smooth' });
					}
				});
			},
			//判断选中云盘是否在当前视口内显示
			isOptionVisible(index) {
				if(!this.$refs[`driveMenu-${index}`]) {
					//如果没有该云盘，则返回true，不执行其他操作
					return true;
				}
				const scrollbar = this.$refs.driveScrollbar.$el.querySelector('.el-scrollbar__wrap');
				const option = this.$refs[`driveMenu-${index}`][0];
				const optionRect = option.getBoundingClientRect();
				const scrollbarRect = scrollbar.getBoundingClientRect();
				
				// 检查元素是否至少部分在视口内
				const isVisible = optionRect.top >= scrollbarRect.top && optionRect.bottom <= scrollbarRect.bottom;
				return isVisible;
			},
			addDriveSelect(index, cloud, flag) {
				// 其他操作
				this.driveOptionSelect(index);
				if (!cloud.rootId) {
					cloud.rootId = "";
				}
				this.$store.commit('setListData', {
					id: cloud.rootId,
					ud: commonUtils.getUser().id,
					dd: cloud.id,
					cloud: cloud
				});
				let pathJson = [{
					id: cloud.rootId,
					name: cloud.name,
					driveId: cloud.id
				}]
				let pathJsonData = this.$store.getters.getPathJson;
				let pathData = pathJson[cloud.rootId + cloud.id];
				let JsonList = Object.assign([], pathJson);
				if (!pathData || (pathData.json[0].driveId != cloud.id)) {
					this.$store.commit("setPathJson", {
						folderId: cloud.rootId + cloud.id,
						json: JsonList
					});
				}
				this.$store.commit('setCloudExploerPasteItems', cloud);
				let path = 'cloudExploer';
				//邮件跳转邮件页面
				if(commonstate.emailClouds.includes(cloud.appName)){
					path = 'emailExploer';
				}
				this.$router.push({
					name: path,
					query: {
						cloudType: cloud.driveType,
						folderId: cloud.rootId,
						folderName: cloud.name,
						tokenId: cloud.id
					}
				});
			}, //点击选项，跳转路径
			handleSelect(index) {
				// 用户好评弹窗（从任务列表切到其它导航）
				index = Number(index);
				if (index!=0 && this.$store.state.isShowUserStarReady) {
					// 下次不显示
					this.$store.state.isShowUserStarReady = false;
					this.$store.state.isShowUserStar = false;
					// 显示弹窗
					this.$refs.userStarPopup.isShowStarPopup = true;
					taskListUtils.userStarUpdateRequest({createReason:1,score:0,trustpilot:false,content:''});
				}
				// this.$parent.$refs.rightContBan.resetEmail = false;
				switch (index) {
					case -1:
						this.$router.push({name: 'homePage'});
						break;
					case 0:
						let taskRedMark = document.getElementById("listRedMark0");
						taskRedMark.style.display = 'none';
					case 100:
						this.$store.state.taskListAddNewNumber=0;
						this.$router.push('/mc_project/task_list');
						break;
					case 101:
						this.$router.push('/mc_project/cloud_transfer');
						break;
                    case 102:
						this.$router.push('/mc_project/team_transfer');
						break;
					case 103:
						this.$router.push('/mc_project/cloud_sync');
						break;
                    case 104:
                        this.$router.push('/mc_project/cloud_backup');
						break;
					case 105:
						this.$router.push('/mc_project/remote_task');
						break;
					case 106:
						this.$router.push('/mc_project/shares');
						break;
					case 107:
						if(!commonUtils.getActiveTagByStore("emailTransferNotNew")){
							// this.menuOptions[index].isNew = false;
							commonUtils.saveActiveTagByUser(this,"emailTransferNotNew",true);
						}
						this.$router.push('/mc_project/email_transfer');
						break;
					case 108:
						this.$router.push('/mc_project/lite_file');
						break;
					case 200:
						if (this.canGA()) taskListUtils.imageSaverRequest("/ga", {gaType:'ins_list_click'});
						this.$store.state.isInsTaskList = true;
						this.$router.push('/mc_project/image_saver_task');
						break;
					case 201:
						if (this.canGA()) taskListUtils.imageSaverRequest("/ga", {gaType:'ins_tag_click'});
						this.$router.push('/mc_project/image_saver_ins');
						break;
					case 300:
						if (this.canGA()) this.$multcloudGA('video_list_click');
						this.$store.state.videlSaverTaskListAddNewNumber=0;
						this.$router.push('/mc_project/video_saver_task');
						break;
					case 301:
						this.$router.push('/mc_project/video_saver');
						break;
					case 400:
						if (this.canGA()) taskListUtils.imageSaverRequest("/ga", {gaType:'web_list_click'});
						this.$store.state.isInsTaskList = false;
						this.$router.push('/mc_project/image_saver_task');
						break;
					case 401:
						if (this.canGA()) taskListUtils.imageSaverRequest("/ga", {gaType:'web_tag_click'});
						this.$router.push('/mc_project/image_saver_web');
						break;
					case 901:
						this.$router.push('/mc_project/add_cloud');
						break;
					case 902:
						this.$router.push('/mc_project/add_email');
						break;
					case 12:
						this.$router.push('/mc_project/inviteFriends');
						break;
					case 903:
					case 8:
						let teamCloud = this.hasTeam;
						if(teamCloud&&teamCloud.id){
							this.$store.commit('setListData', {
								id: teamCloud.rootId,
								ud: commonUtils.getUser().id,
								dd: teamCloud.id,
								cloud: teamCloud
							});
								let pathJson = [{
									id: "/",
									name: this.$t('language.common.team'),
									driveId: teamCloud.id
								}]
								let JsonList = Object.assign([], pathJson);
								this.$store.commit("setPathJson", {
									folderId: "/" + teamCloud.id,
									json: JsonList
								});
								this.$router.push({
									name:'subAccountTeam',
									query: {
										cloudType: "team",
										folderId: "/",
										folderName: this.$t('language.common.team'),
										tokenId: teamCloud.id,
										cloudId: teamCloud.id,
										name: "root",//确定显示team根目录
									}
								});
							}
						break;
					case 9:
						this.$router.push('/mc_project/affiliateProgram');
						break;
					default: 
						if(this.tabCategories==1) {
							this.$router.push({name: 'homePage'});
						}else if(this.tabCategories==2) {
							this.$router.push('/mc_project/image_saver_ins');
						}else if(this.tabCategories==4) {
							this.$router.push('/mc_project/image_saver_web');
						}
						break;
				}
			},
			// 是否可以记录GA
			canGA() {
				var now = new Date().getTime();
				var flag = now - this.lastGATime > 500;
				this.lastGATime = now;
				return flag;
			},
			//显示详情
			propertiesDialogShow() {
                let that = this;
				this.editShow = false;
                let getData=new addCloudUtils.getData(commonUtils.getUser().id,this.selectItem.id);
                that.Utils.doDrivesRequest("get", getData).then(res => {
                     if (res.status == 200) {
                           this.selectItem.driveInfo = res.drive;
                           //this.selectItem.driveInfo = res.drive.usedSpace;
                        //    if(res.drive.username){
                        //        this.selectItem.driveInfo.username=res.drive.username;
                        //    }
                        //     if(res.drive.email){
                        //        this.selectItem.driveInfo.username=res.drive.email;
                        //    }
                           addCloudUtils.openProperties(that,res.drive.totalSpace,res.drive.usedSpace);
                     }
                });
			}, //显示删除云盘菜单
			removeDialogShow() {
				let that = this;
				this.editShow = false;
				this.cloudId = this.clouds[this.cloudIndex].id;
				let allTasklistData = that.$store.state.taskListArr;
				$.each(allTasklistData, function(index, data) {
					if (!data.sources) {
						if ((data.fromItem.driveId == that.cloudId || data.toItem.driveId == that.cloudId)) {
							that.$refs.removeDialog.removeShow = true;
							return false;
						}
					} else if (data.sources) {
						$.each(data.sources, function(m, item) {
							if ((data.fromItem.driveId == that.cloudId || data.toItem.driveId == that.cloudId || item.fromItem.driveId ==
								that.cloudId || item.toItem.driveId == that.cloudId)) {
								that.$refs.removeDialog.removeShow = true;
								return false;
							}
						});
					}
					if (index == allTasklistData.length - 1 && !that.$refs.removeDialog.removeShow) {
						addCloudUtils.deletePage(that.cloudId, that);
					}
				});
				if (!allTasklistData.length) {
					addCloudUtils.deletePage(that.cloudId, that);
				}
			},
			//编辑云盘
			rewriteDrive() {
				this.$refs.editCloudDialog.cloudName = this.clouds[this.cloudIndex].appName;
				this.$refs.editCloudDialog.cloudInfo = this.clouds[this.cloudIndex];
				this.$refs.editCloudDialog.cloudIcon = this.clouds[this.cloudIndex].appName;
				this.editShow = false;
				if (this.clouds[this.cloudIndex].appName == 'FTP') {
					this.$refs.editFtpDialog.ftpDialog = true;
					this.$refs.editFtpDialog.cloudInfo = this.clouds[this.cloudIndex];
					let ftpInfo = this.clouds[this.cloudIndex].driveInfo;
					addCloudUtils.openFtpInfo(ftpInfo, this);
				} else if (this.clouds[this.cloudIndex].appName == 'NAS') {
					let nasInfo = this.clouds[this.cloudIndex].driveInfo;
					addCloudUtils.openNasInfo(nasInfo, this);
				} else {
					if(this.clouds[this.cloudIndex].appName == 'iCloudPhotos' || this.clouds[this.cloudIndex].appName == 'iCloudDrive'){
						this.$refs.editCloudDialog.appleId = '';
						this.$refs.editCloudDialog.password = '';
					}
					this.$refs.editCloudDialog.editCloudShow = true;
					this.$refs.editCloudDialog.inputCloudNameValue = this.clouds[this.cloudIndex].name;
					this.$refs.editCloudDialog.email = this.clouds[this.cloudIndex].driveInfo.email;
					this.cloudName = this.clouds[this.cloudIndex].appName;
					this.cloudId = this.clouds[this.cloudIndex].id;
					this.$refs.editCloudDialog.tipShow = false;
					this.$nextTick(function() {
						addCloudUtils.getContainerHeight(this.$refs.editCloudDialog);
					});
				}
			}, 
			//删除云盘成功
			deleCloudSuccess() {
				return new Promise((resolve, reject) => {
					let that = this;
					let deleteCloud = this.clouds[this.cloudIndex];
					
					this.clouds = this.clouds.filter(function (cloud) {
						return cloud.id != deleteCloud.id;
					});
					let allCloud = Object.assign([], this.clouds);
					$.each(allCloud, function(m, mCloud) {
						if (mCloud.children) {
							delete mCloud.children;
						}
					});
					this.$store.commit("setUsersDrives", allCloud);
					taskListUtils.delteHavaTask(that.cloudId);
					this.betchDeleteOfflineTask(commonUtils.getUser().id, that.cloudId);
					if (this.$parent.$refs.routView.clouds) {
						this.$parent.$refs.routView.clouds = this.clouds;
					}
					if (this.clouds.length == 0) {
						this.menuOptionSelect(901);
					}
					if (this.$route.name == 'cloudExploer' && deleteCloud.id == this.$route.query.tokenId) {
						this.menuOptionSelect(901);
					}
					if (this.$route.name == 'emailExploer' && deleteCloud.id == this.$route.query.tokenId) {
						this.menuOptionSelect(11);
					}
					resolve(true); // 删除成功，将布尔值传递给调用方
				})
			},
			 //跳转到老版本
			switchOldVersion() {
				// let language = commonUtils.getLocaleTo(localStorage.getItem("locale"));
				// var tmp = new Date().getTime();
				//window.location.href = commonstate.oldVersionUrl + "/index.jsp?rl=" + language + "&tmp=" + tmp + "#home";
				var user = commonUtils.getUser();
				window.location.href = commonstate.oldVersionUrl + "/action/userinfo!switchOld?ud="+user.id+"&salt="+user.salt;
			}, // 批量删除离线任务
			betchDeleteOfflineTask(ud, dd) {
				let that = this;
				let urlDeleteData = taskOfflineUtils.deleteUrl(ud, dd);
				this.Utils.doTasksRequest("cancel", urlDeleteData).then(res => {
					that.updateOfflineStore(dd);
				});
				let torrentDeleteData = taskOfflineUtils.deleteTorrent(ud, dd);
				this.Utils.doTorrentRequest("deleteBetch", torrentDeleteData).then(res => {
					that.updateOfflineStore(dd);
				});
			}, // 更新离线任务缓存
			updateOfflineStore(dd) {
				const vm = window.vm.$children[0].$refs.routerView.$refs.routView;
				if(vm.offlineTaskData){
					vm.refresh()
				}else{
					let offlineTaskData = this.$store.state.remoteTaskArr;
					let offlineList = [];
					if (offlineTaskData) {
						offlineTaskData.forEach(task => {
							let driveId = task.toItem.driveId;
							if (driveId != dd) {
								offlineList.push(task)
							}
						});
						this.$store.commit("setRemoteTaskArr", offlineList);
					}
				}
			},
			//查询是否有别人给予的权限（是否是别人的子账号）
			hasPermission(){
				// console.log(this.$store.getters.getTeamCloud)
				// let that = this;
				// this.hasTeam = this.$store.getters.getTeamCloud;
				// this.Utils.doDrivesRequest("has_limits", {ud:commonUtils.getUser().id}).then(res => {
				// 	if(res.status=="200" && res.teamCloud){
				// 		that.$store.commit("setTeamCloud", res.teamCloud);
				// 		that.hasTeam = res.teamCloud;
				// 	}else{
				// 		that.$store.commit("setTeamCloud", {});
				// 		that.hasTeam = {};
				// 	}
				// })
			},
			//获取对应缓存的新增标记数
			getMenuOptionNewNum(name) {
                if(this.$route.name == 'taskList')return false;
				let num = this.$store.getters[name];
				if(num&&num>0) {
					if(num<100) {
						return num;
					}else {
						return '99+';
					}
				}else {
					return false;
				}
			},
			//判断菜单栏是否显示邮件
			hideEmail(cloud) {
				let categoryInfo =  cloud.categoryInfo;

				if(this.tabCategories!=1&&categoryInfo&&(categoryInfo.id=='101'||categoryInfo.id=='53')) {
					//满足条件则不显示邮件
					return true;
				}
			}
		},
	}
</script>

<style>
	.left-banner {
		width: 260px;
		/*no*/
		height: 100%;
		background-color: #DCE4F5;
		float: left;
		box-sizing: border-box;
		background-size: cover;
		min-height: 510px;
		/*no*/
	}

	/* 品牌logo */
	.cloud-icon {
		width: 100%;
		height: 90px;
		/*no*/
		box-sizing: border-box;
		display: flex;
		align-items: center;
		vertical-align: middle;
		line-height: 50%;
		cursor: pointer;
		background: #293166;
	}

	.cloud-icon-position {
		width: 100%;
		height: 100%;
	}

	.cloud-image {
		height: 40px;
		/*no*/
		background-image: url("../../assets/images/logo.svg");
        background-size: 100% 100%;
        background-position-x: -27px;/*no*/
		position: relative;
		margin: 25px;
		/*no*/
        margin: 30px 16px 0 16px;/*no*/
	}

	.cloud-description {
		font-size: 9px;/*no*/
		color: #FFF;
		position: relative;
		left: 87Px;
		margin: 0;
		top: -13Px;
		float: left;
		width: 200Px;
		line-height: 13Px;
	}

	/* 导航菜单 */
	.navigation-menu {
		width: 100%;
		height: calc(100% - 90px);/*no*/
		transition: height 0.5s;
		overflow-x: hidden;
		display: flex;
		flex-direction: column;
	}

	.navigation-menu::-webkit-scrollbar {
		width: 0px;
		/*no*/
		/*宽度*/
		border-radius: 5px;
		/*no*/
		background-color: #35363a;
		/*背景颜色*/
	}

	.navigation-menu::-webkit-scrollbar-thumb {
		height: 1px;
		/*no*/
		border-radius: 5px;
		/*no*/
		background-color: #becae4;
	}

	.menu-option-title {
		margin-top: 20px;/*no*/
		padding-left: 20px;/*no*/
		width: auto;
		height: 26px;/*no*/
		font-size: 14px;/*no*/
		font-weight: bold;
		color: #9DA8D3;
		line-height: normal;
		letter-spacing: 0em;
	}

	.function-menu {
		margin-bottom: 10px;/*no*/
	}

	.add-menu {
		
	}

	.drive-menu {
		flex-grow: 1;
		position: relative;
		min-height: 70px;/*no*/
	}

	.footer-menu {
		padding: 10px 0;/*no*/
	}

	.footer-menu .menu-option {
		height: 40px;/*no*/
		line-height: 40px;/*no*/
	}

	.menu-options {
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: flex-start;
		gap: 0px;
		/*no*/
	}

	.menu-option {
		width: 240px;
		/*no*/
		height: 44px;
		/*no*/
		line-height: 44px;
		/*no*/
		font-size: 14px;
		/*no*/
		color: #2D3870;
		box-sizing: border-box;
    	position: relative;
		cursor: pointer;
		margin: 0 10px;
		/*no*/
		padding: 12px;
		/*no*/
		border-radius: 8px;
		/*no*/
		display: flex;
		justify-content: flex-start;
		align-items: center;
	}

	.menu-option:hover {
		background: #C1CBE3;
	}

	.menu-option.menu-option-select {
		color: #F2F7FE;
		background: #5562B4;
	}
	
	.option-name {
		flex-grow: 1;
		position: relative;
		margin-left: 20px;
		/*no*/
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
	}

	.menu-option[data-type=googlePhotosV2]:hover .option-name {
		overflow: visible;
	}

	.menu-option[data-type=googlePhotosV2]:hover .option-email-btn {
		display: block;
	}

	.option-email-btn {
		display: none;
		height: 170px;
		font-size: 16px;
		text-align: center;
		padding: 10px 30px;
		border-radius: 10px;
		border: 1px solid #cbd4e8;
		background-color: #FFF;
		cursor: default;
		position: fixed;
		z-index: 3;
		left: 0px;
		top: 0px;
	}

	.option-email-btn>.googlePhotos_big {
		transform: scale(0.6);
	}

	.option-email { 
		color: #000;
		font-weight: bold;
		position: relative;
		top: -25px;
	}

	.option-btn>button {
		cursor: pointer;
		color: #2D3870;
		padding: 0px 20px !important;
		border-radius: 8px;
		background-color: #dce4f5;
		height: 36px;
		line-height: 36px;
		position: relative;
		top: -25px;
	}

	.option-btn>button:hover {
		background-color: #5562B4;
		color: #FFF;
	}

	.option-icon {
		width: 24px;
		/*no*/
		height: 24px;
		/*no*/
		border-radius: 4px;
		/*no*/
		background-color: #ffffff;
		display: block;
	}

	.option-icon img {
		width: 20px;
		/*no*/
		height: 20px;
		/*no*/
		margin: 2px;
		/*no*/
		display: block;
		max-width: none;
	}

	.option-num {
		top: 10px;/*no*/
		right: 10px;/*no*/
		position: absolute;
		display: flex;
		flex-direction: row;
		justify-content: center;
		align-items: center;
		padding: 0px 8.5px;/*no*/
		background: linear-gradient(270deg, #FF7913 0%, #FF4646 102%), #F54531;
		box-shadow: 0px 4px 8px 0px rgba(255, 26, 0, 0.2);/*no*/
		width: auto;
		min-width: 20px;/*no*/
		height: 24px;/*no*/
		border-radius: 13px;/*no*/
		font-family: Roboto;
		font-size: 12px;/*no*/
		font-weight: bold;
		line-height: normal;
		letter-spacing: 0em;
		color: #fff;
	}

	/* 修改云盘名 */
	.edit-innerclass {
		width: 165px;
		/*no*/
		height: 35px;
		/*no*/
		margin-left: 5px;
		/*no*/
		float: left;
		position: relative;
	}

	.drive-input-icon {
		position: absolute;
		top: 7px;
		/*no*/
		right: -3px;
		/*no*/
	}

	.drive-name-edit {
		background: #fff !important;
		margin-top: 7px;
		/*no*/
		height: 25px;
		/*no*/
		width: 150px;
		/*no*/
		float: left;
		margin-left: 10%;
		font-size: 14px;
		/*no*/
		padding: 0px 40px 0px 0px;
		/*no*/
		border: none !important;
		float: left;
		box-sizing: border-box;
	}

	/* 云盘菜单列表 右键菜单 */
	.edit-drive-menu:hover {
		background-color: #ebf3fe;
		cursor: pointer;
	}

	.edit-drive-position {
		float: left;
		margin: 7px 10px 0 0;
		/*no*/
	}

	/* 新手导航 */
	.step-one {
		flex-direction: column;
		align-items: center;
		display: flex;
		height: 352px;/*no*/
        width: 240px;/*no*/
        display: block;
        float: left;
        position: absolute;
        z-index: 201;
        top: 137px;/*no*/
        left: 10px;/*no*/
        box-shadow: 0 0 0 8888Px rgba(0, 0, 0, 0.5);
		border-radius: 8px;/*no*/
	}

	.step-two {
		box-shadow: 0 0 0 8888Px rgba(0, 0, 0, 0.5);
		flex-direction: column;
		align-items: center;
		display: flex;
	    height: 88px;/*no*/
        width: 240px;/*no*/
        display: block;
        float: left;
        position: absolute;
        z-index: 250;
        top: 545px;/*no*/
        left: 10px;/*no*/
		border-radius: 8px;/*no*/
	}

	.step-ins {
		flex-direction: column;
		align-items: center;
		display: flex;
		height: 44px;/*no*/
        width: 240px;/*no*/
        display: block;
        float: left;
        position: absolute;
        z-index: 201;
        top: 136px;/*no*/
        left: 10px;/*no*/
        box-shadow: 0 0 0 8888Px rgba(0, 0, 0, 0.5);
		border-radius: 8px;/*no*/
	}

	.step-google-photos-v2-tips-box {
		width: 100%;
		height: 100%;
		position: absolute;
		z-index: 3;
		left: 0;
		top: 0;
	}

	.step-google-photos-v2-tips-box2 {
		width: 100%;
		height: 100%;
		position: absolute;
		z-index: 101;
		left: 0;
		top: 0;
	}

	.step-google-photos-v2-tips {
		flex-direction: column;
		align-items: center;
		display: flex;
		height: 44px;/*no*/
        width: 135px;/*no*/
        display: block;
        float: left;
        position: absolute;
        z-index: 201;
        top: 144px;/*no*/
        left: 298px;/*no*/
        box-shadow: 0 0 0 8888Px rgba(0, 0, 0, 0.5);
		border-radius: 8px;/*no*/
	}

	.step-google-photos-v2-tips[language=deutsch] {
		width: 185px;
	}
	.step-google-photos-v2-tips[language=deutsch] .bubble-google-position {
		left: 205px;
	}
	.step-google-photos-v2-tips[language=france] {
		width: 175px;
	}
	.step-google-photos-v2-tips[language=france] .bubble-google-position {
		left: 195px;
	}
	.step-google-photos-v2-tips[language=portuguese] {
		width: 155px;
	}
	.step-google-photos-v2-tips[language=portuguese] .bubble-google-position {
		left: 175px;
	}
	.step-google-photos-v2-tips[language=nederlands] {
		width: 165px;
	}
	.step-google-photos-v2-tips[language=nederlands] .bubble-google-position {
		left: 185px;
	}
	.step-google-photos-v2-tips[language=traditionalChinese] {
		width: 115px;
	}
	.step-google-photos-v2-tips[language=traditionalChinese] .bubble-google-position {
		left: 135px;
	}
	.step-google-photos-v2-tips[language=chinese] {
		width: 115px;
	}
	.step-google-photos-v2-tips[language=chinese] .bubble-google-position {
		left: 135px;
	}

	.step-google-photos-v2-tips2 {
		flex-direction: column;
		align-items: center;
		display: flex;
		height: 44px;/*no*/
        width: 44px;/*no*/
        display: block;
        float: left;
        position: absolute;
        z-index: 201;
        top: 600px;/*no*/
        left: 1042px;/*no*/
        box-shadow: 0 0 0 8888Px rgba(0, 0, 0, 0.5);
		border-radius: 8px;/*no*/
	}

	.step-google-photos-v2-tips2>.add-more-photos-icon {
		position: absolute;
		left: 16px;
		top: 15px;
	}

	.bubble {
		width: 384px;
		/*no*/
		min-height: 135px;
		/*no*/
		background-color: #FFF;
		position: relative;
		z-index: 201;
		padding: 20px 20px;
		/*no*/
		display: flex;
    	flex-direction: column;
		box-sizing: border-box;
	}

	.bubble-google-position {
		left: 155px;
		top: 0px;
	}

	.bubble-google-position2 {
		left: 62px;
		top: -8px;
	}

	.bubble-one-position {
		left: 260px;
		/*no*/
		top: 0px;
		/*no*/
	}

	.bubble-two-position {
		left: 260px;
		/*no*/
		top: -65px;
		/*no*/
	}

	.bubble-three-position {
		left: 250px;
		/*no*/
		top: -192px;
		/*no*/
	}

	.edit-outclass {
		width: 235px;
		/*no*/
		height: 40px;
		/*no*/
	}

	.bubble-title {
		font-size: 24px;
		/*no*/
		color: #5065bc;
		font-weight: bold;
		margin-top: 35px;
		/*no*/
	}

	.bubble-text {
		margin: 30px 0;
		/*no*/
		font-family: Arial;
		font-size: 18px;
		/*no*/
		font-weight: normal;
		line-height: normal;
		letter-spacing: 0em;
	}

	.bubble-button {
		margin-left: auto;
		min-width: 120px;
		/*no*/
	}
	
	.bubble-close {
		width: 15px;
		/*no*/
		height: 15px;
		/*no*/
		background-position: -1205px -250px;
		/*no*/
		cursor: pointer;
		position: absolute;
		top: 25px;
		/*no*/
		right: 25px;
		/*no*/
	}

	.bubble-triangle::after {
		content: '';
		width: 0;
		height: 0;
		border: 16px solid;
		/*no*/
		position: absolute;
		top: 15px;
		/*no*/
		left: -32px;
		/*no*/
		border-color: #fff transparent transparent;
		transform: rotate(90deg);
	}

    .bubble-triangleThree::after {
		content: '';
		width: 0;
		height: 0;
		border: 20px solid;/*no*/
		position: absolute;
		bottom: 0px;/*no*/
		right: 500px;/*no*/
		border-color: #fff transparent transparent;
		-webkit-transform: rotate(90deg);
		transform: rotate(90deg);
    }

	.lite_switch_span {
		width: 240px;
		height: 1px;
		margin: 10px;
		box-sizing: border-box;
		background-color: #d0d8e9;
	}
</style>



// WEBPACK FOOTER //
// src/components/common/left_banner.vue